// extracted by mini-css-extract-plugin
export default {"plus":"plus__3aUKVWYM","bold":"bold__Dccj1Mp1","typoContainer":"typoContainer__vGtkbQjc","leftMargin":"leftMargin__V2zqUsAT"};